

























































































































import { computed, defineComponent, onMounted, ref, toRef, toRefs, watch } from '@vue/composition-api';
import {
  LoadingIcon,
  SearchIcon,
  CheckIcon,
  CloseIcon,
  ChevronRightIcon,
  FolderAddIcon,
  StarIcon,
  ForkIcon,
  UsergroupIcon,
  UserIcon,
  ArrowLeftIcon,
} from 'tdesign-icons-vue';
import _ from 'lodash';

import TeamTree from '@/renderer/components/TeamTree/index.vue';
import Breadcrumb from '@/renderer/components/SpacePage/components/Breadcrumb.vue';
import PreviewStencilFile from '@/renderer/components/dialog/SelectFilePath/components/PreviewStencilFile.vue';

import stencilHandler, { ListItem } from '@/renderer/components/dialog/SelectFilePath/compositions/stencilHandler';

import { getFileIcon } from '@/renderer/scripts/utils/tools/index';
import { SMH } from '@/renderer/scripts/smh';
import i18n, { i18n_t } from '@/locales/i18n';

export default defineComponent({
  name: 'SelectStencilPath',
  components: {
    TeamTree,
    Breadcrumb,
    PreviewStencilFile,
    LoadingIcon,
    SearchIcon,
    CheckIcon,
    CloseIcon,
    ChevronRightIcon,
    FolderAddIcon,
    StarIcon,
    ForkIcon,
    UsergroupIcon,
    UserIcon,
    ArrowLeftIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    selectedStencilList: {
      required: false,
      type: Array as () => Array<ListItem>,
      default: () => [],
    },
  },
  setup(props, context) {
    const store = context.root.$store;

    const innerShow = computed({
      get: () => props.show,
      set: val => {
        context.emit('update:show', val);
      },
    });

    const {
      stencilMenu,
      fileTypeSelect,
      selectedList,
      initSelectedList,
      stencilData,
      loading,
      isSearching,
      templateName,
      fileType,
      methods: stencilMethods,
    } = stencilHandler('space');

    // 默认初始化菜单栏为全部
    const menuValue = ref('all');
    // 记录搜索前的menuValue, 用于回退搜索
    const lastMenuValue = ref('');
    // 当前类型名词
    const currentTypeName = computed(() => {
      let typeName = i18n_t('全部');
      if (menuValue.value === 'selected') {
        typeName = i18n_t('已选择');
      } else {
        stencilMenu.value.forEach((item: SMH.StencilTypeData) => {
          if (item.templateType === menuValue.value) {
            typeName = item.templateTypeCN;
          }
        });
      }
      return typeName;
    });

    const isPreviewStencil = ref(false);
    const stencilId = ref(0);
    const methods = {
      async initData() {
        await stencilMethods.stencilPullList(menuValue.value);
      },
      initStatus() {
        isSearching.value = false;
        templateName.value = '';
        fileType.value = 'all';
      },
      onSearchStencil() {
        if (!isSearching.value) {
          lastMenuValue.value = menuValue.value;
        }
        menuValue.value = '';
        stencilMethods.onSearch();
      },
      exitSearch() {
        methods.initStatus();
        menuValue.value = lastMenuValue.value;
        stencilMethods.stencilPullList(menuValue.value);
      },
      onfileTypeChange(val: string) {
        fileType.value = val;
        methods.onSearchStencil();
      },
      // 点击1次选中模板，两次取消选中
      onClickStencil(item: ListItem) {
        item.checked = !item.checked;
      },
      // 预览模板文件
      previewStencil(e: Event, item: ListItem) {
        isPreviewStencil.value = true;
        stencilId.value = item.id;
        e.stopPropagation();
      },
      onSubmit() {
        innerShow.value = false;
        context.emit('submit', selectedList.value);
      },
    };

    onMounted(async () => {
      // 加载模板数据
      await stencilMethods.stencilPullType();
    });

    watch(
      () => innerShow.value,
      async val => {
        menuValue.value = 'all';
        if (val) {
          // 重新打开弹窗初始化数据
          methods.initStatus();
          await methods.initData();
          initSelectedList.value = [];
          stencilData.stencilList = stencilData.stencilList.map(item1 => {
            // 判断是否已勾选
            const selectData = props.selectedStencilList.find(item2 => item2.id === item1.id);
            return { ...item1, checked: !!selectData };
          });
        }
      },
    );

    watch(
      () => menuValue.value,
      (newval, oldVal) => {
        if (newval && innerShow.value) {
          methods.initStatus();
          if (menuValue.value !== 'selected') {
            stencilMethods.stencilPullList(menuValue.value);
          } else {
            stencilData.stencilList = Array.from(
              selectedList.value.reduce((map, item) => map.set(item.id, item), new Map()).values(),
            );
          }
        }
      },
    );
    return {
      innerShow,
      menuValue,
      currentTypeName,
      getFileIcon,

      // 文件模板相关
      stencilMenu,
      fileTypeSelect,
      loading,
      isSearching,
      templateName,
      fileType,
      selectedList,
      ...toRefs(stencilData),
      ...stencilMethods,

      isPreviewStencil,
      stencilId,

      ...methods,
    };
  },
});
